import { render, staticRenderFns } from "./xianYuLink.vue?vue&type=template&id=542f7a18&scoped=true&"
import script from "./xianYuLink.vue?vue&type=script&lang=js&"
export * from "./xianYuLink.vue?vue&type=script&lang=js&"
import style0 from "./xianYuLink.vue?vue&type=style&index=0&id=542f7a18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f7a18",
  null
  
)

export default component.exports